import PVSMIPCreateFolderModal from "./PVSMIPCreateFolderModal";

export default PVSMIPCreateFolderModal;
